import type { SerializedError } from "@reduxjs/toolkit";
import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { EXCEL_UPLOAD_SIZE_MESSAGE } from "../constants/notice";

// 엑셀 업로드 실패 응답을 화면 문구로 변환 (이행매장 엑셀 VMD-392, 이행평가 피드백 VMD-389 공용)
//  - 413: 서버 message 가 영문 → 고정 한글 문구(EXCEL_UPLOAD_SIZE_MESSAGE)로 치환
//  - 400: 서버가 내려준 한글 message 그대로 노출 (없으면 기본 문구)
//  - 403: 서버 message 그대로 노출. 없으면 권한 안내 문구 (재시도해도 같으므로 "잠시 후 다시 시도" 문구를 쓰지 않는다)
//  - 그 외(다른 status, FETCH_ERROR, SerializedError 등): 공통 안내 문구
// ExcelStoreUploadModal 에서 쓰던 비공개 함수를 단위 테스트 가능하도록 분리했다.
export const UPLOAD_DEFAULT_ERROR_MESSAGE = "엑셀 업로드 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.";
export const UPLOAD_FORBIDDEN_MESSAGE = "업로드 권한이 없습니다.";

// 서버 에러 응답 본문에서 message 문자열 추출 (형식이 다르면 undefined)
export const getServerMessage = (data: unknown): string | undefined => {
  if (typeof data === "object" && data !== null && "message" in data) {
    const message = (data as { message?: unknown }).message;
    if (typeof message === "string" && message) return message;
  }
  return undefined;
};

export const getUploadErrorMessage = (error: unknown): string => {
  // unwrap() 이 던지는 에러는 FetchBaseQueryError | SerializedError. HTTP 상태 분기는 status 가 있는 경우에만 가능
  const queryError = error as FetchBaseQueryError | SerializedError | undefined;
  if (!queryError || !("status" in queryError)) return UPLOAD_DEFAULT_ERROR_MESSAGE;
  if (queryError.status === 413) return EXCEL_UPLOAD_SIZE_MESSAGE;
  if (queryError.status === 400) return getServerMessage(queryError.data) ?? UPLOAD_DEFAULT_ERROR_MESSAGE;
  if (queryError.status === 403) return getServerMessage(queryError.data) ?? UPLOAD_FORBIDDEN_MESSAGE;
  return UPLOAD_DEFAULT_ERROR_MESSAGE;
};
